import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Drawer, IconButton, Popover } from "@mui/material";
import { useAuth } from "src/auth";
import { getReviewConfig } from "src/const/Defaults";
import { TankInfosQuery } from "types/graphql";
import ReviewCard from "../ReviewCard/ReviewCard";
import { faComment } from "@fortawesome/free-regular-svg-icons";
import { faFeather } from "@fortawesome/free-solid-svg-icons";


const ReviewPopupButton = ({ review, className = "" }: { review: TankInfosQuery["tank"]["lastReview"], className?: string }) => {
  const { hasRole } = useAuth()
  
  const [open, setOpen] = React.useState(false);

  const toggleDrawer = (newOpen: boolean) => () => {
    setOpen(newOpen);
  };
  const reviewConfig = getReviewConfig()

  return (
    <>
      <IconButton className={className} onClick={toggleDrawer(true)}>
        {!!review?.state 
        ? <FontAwesomeIcon className={reviewConfig[review?.state].color} icon={reviewConfig[review?.state].icon}/>
        : <FontAwesomeIcon icon={faFeather}/>
      }
      </IconButton>
      <Drawer
            anchor={"right"}
            open={open}
            onClose={toggleDrawer(false)}
            PaperProps={{
              sx:{width: {md:"33vw", sm:"50vw", xs:"80vw"}}
            }}
            
            
          >
        <ReviewCard review={review} defaultExpanded />
      </Drawer>
    </>
  )
}

export default ReviewPopupButton
